import { useState, useEffect, useCallback } from "react";
import { getModels, getUserModels } from "../apis/model";

export const useModelData = (apiType = "admin"): { models: any[]; loading: boolean } => {
  const [models, setModels] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchModelData = useCallback(async () => {
    setLoading(true);
    try {
      let modelData;
      if (apiType === "admin") {
        modelData = await getModels();
      } else {
        modelData = await getUserModels();
      }
      setModels(modelData);
    } catch (error) {
      console.error("Server error", error);
    } finally {
      setLoading(false);
    }
  }, [apiType]);

  useEffect(() => {
    fetchModelData();
  }, [fetchModelData]);

  return { models, loading };
};
